export default {
  default: 0,
  contain :1
}
